var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearchInformed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Values"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.00098 3H10.0078C10.6459 3 11.2295 3.24773 11.6748 3.65039L12.0098 3.9541L12.3457 3.65039C12.7909 3.2479 13.3738 3.00008 14.0117 3H20.999L21.0996 3.01074C21.3269 3.05789 21.4998 3.26054 21.5 3.49902V18.4912C21.5 18.7641 21.2741 18.9912 20.999 18.9912H15.2334C14.5773 18.9912 13.9305 19.2656 13.4688 19.7266L12.3965 20.7969L12.375 20.8086L12.3174 20.8662C12.2818 20.9017 12.2342 20.9349 12.1816 20.96C12.115 20.9869 12.0527 21 12 21C11.947 21 11.8844 20.9871 11.8174 20.96C11.7771 20.9402 11.7319 20.9085 11.6611 20.8457L11.6592 20.8467C11.6429 20.8322 11.6282 20.8187 11.6143 20.8086L10.5312 19.7266C10.0648 19.251 9.42614 18.9912 8.7666 18.9912H3.00098C2.72586 18.9912 2.5 18.7641 2.5 18.4912V3.49902C2.50025 3.22638 2.72601 3.00001 3.00098 3ZM3.50195 17.9922H8.7666C9.46353 17.9922 10.1493 18.2095 10.7324 18.5977L11.5088 19.1152V5.49805C11.5086 4.67165 10.8337 3.99902 10.0078 3.99902H3.50195V17.9922ZM14.0117 3.99902C13.186 3.99918 12.5109 4.67174 12.5107 5.49805V19.1152L13.2881 18.5977C13.8711 18.2096 14.5562 17.9923 15.2529 17.9922H20.5176V3.99902H14.0117Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchInformed);
export default __webpack_public_path__ + "static/media/research-informed.d7ec71f1ee8731a7d52346e0aa7885a5.svg";
export { ForwardRef as ReactComponent };